import { makeStyles } from "@material-ui/core/styles";

export const useStyles2 = makeStyles({
  table: {
    minWidth: 500,
  },
});
